const styles = (theme) => {
  return {
    root: {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      zIndex: '1',
      top: '35%',
      height: '100vh'
    },
    NeedHelp: {
      color: '#aaa',
      display: 'grid',
      padding: '10px',
      fontSize: '0.90rem',
      float: 'left',
      width: '33.3333%',
      textAlign: 'left'
    },
    logo: {
      color: '#aaa',
      display: 'flex',
      padding: '10px',
      fontSize: '0.90rem',
      float: 'left',
      //width: '100%',
      width: '33.3333%',
      justifyContent: 'center'
    },
    exit: {
      color: '#aaa',
      display: 'grid',
      padding: '10px',
      fontSize: '0.90rem',
      float: 'left',
      width: '33.3333%',
      textAlign: 'right'
    },
    labelClass: {
      padding: '0px 35px'
    },
    spanLink: {
      cursor: 'pointer'
    },
    ExitlabelClass: {
      padding: '0px 35px 0px 0px'
    },
    dialogBackground: {
      background: 'transperent'
    },
    dialogContentColor: {
      color: '#77818D',
      textAlign: 'center',
      fontSize: '1.9em',
      fontWeight: '500',
      width: '95%',
      borderRadius: '15px',
      border: '2px solid #ccc',
      padding: '15px',
      boxShadow: '0px 0px 30px 4px #888'
    },
    alignButton: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    buttonColor: {
      //color: '#387371',
      color: 'black',
      fontSize: '1.9em'
    },
    imgProperty: {
      // opacity: '0.5'
    },
    headerTitle: {
      height: '150px',
      backgroundColor: '#007dc1',
      fontSize: '8rem',
      textTransform: 'uppercase',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontStyle: 'italic',
      fontWeight: 700,
      marginBottom: '5%'
    },
    sorry: {
      color: '#000',
      textTransform: 'uppercase',
      fontSize: '8rem',
      fontWeight: 600,
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'center',
      height: '150px'
    },
    temporarily: {
      color: '#000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '80px',
      fontSize: '5rem',
      textTransform: 'uppercase',
      fontWeight: 600
    },
    outofservice: {
      color: '#000',
      textTransform: 'uppercase',
      fontSize: '5rem',
      height: '90px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 600
    },
    primaryButton: {
      marginTop: '1em',
      //background: 'linear-gradient(135deg, #50A684 30%, #115E67 90%)',
      background: ' #2F5597',
      borderRadius: '10px',
      color: '#fff',
      fontSize: '20px',
      width: '30%',
      '&:hover': {
        background: ' #2F5597'
      }
    },
    '@media only screen and (min-width: 1440px) and (orientation:landscape)': {
      logo: {
        color: '#aaa',
        display: 'grid',
        padding: '10px',
        fontSize: '0.90rem',
        float: 'left',
        width: '33.3333%',
        justifyContent: 'center'
      },
      imgProperty: {
        height: '70px'
      }
    }
  };
};

export default styles;
